import { useCallback, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Icon from 'src/components/Icon';
import { HOME_BANNER_GLOBAL, HOME_BANNER_KR } from 'src/constants/banner';
import { KY_BIXBY_NAME, KY_KARAOKE_NAME, KY_PREFIX_KARAOKE, KY_PREFIX_BIXBY } from 'src/constants/ky';
import { PRODUCT_CATEGORY, PRODUCT_REGION } from 'src/constants/product';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { getUrlToHistory, isKorean } from 'src/services/util';
import { useUser } from 'src/UserContext';

interface Banner {
  title: string;
  prefixCategory: string;
  category: string;
  link: string;
  bgColor: string;
  bgImage: string;
  icon: string;
}
function BannerItem({ prefixCategory, category, title, link, bgColor, bgImage, icon }: Banner) {
  const history = useCustomHistory();

  const goLink = useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();

      const urls = getUrlToHistory(link);
      history.push(urls[0], urls[1]);
    },
    [link],
  );

  return (
    <div onClick={goLink} style={{ backgroundColor: bgColor }} className="relative rounded px-5 py-6">
      <div
        style={{ backgroundImage: `url(${bgImage})` }}
        className="absolute top-0 right-0 w-full h-full bg-contain bg-no-repeat bg-right-top rounded"
      ></div>
      <div
        className="absolute right-0 top-0 h-full"
        style={{
          maxWidth: '144px',
          width: '46%',
          background: `url(${icon}) 100% center no-repeat`,
          backgroundSize: '100% auto',
        }}
      ></div>
      <div>
        <div className="flex items-center">
          <div className="N_10_R text-white">{prefixCategory}</div>
          <div className="division mx-1.5" style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }}></div>
          <div className="N_10_R text-white">{category}</div>
        </div>
        <p className="N_16_R mt-1 text-white w-7/12" style={{ wordBreak: 'keep-all' }}>
          {title}
        </p>
        <button onClick={goLink} className="N_12_R mt-2.5 text-white opacity-60 flex flex-row items-center">
          <span>
            <Trans i18nKey="home/banner_more_button_title"></Trans>
          </span>
          <Icon name="arrow_w" size="12" className="ml-0.5" />
        </button>
      </div>
    </div>
  );
}

export default function BannerList(): JSX.Element {
  const { t, i18n } = useTranslation();
  const { isInit, isLogin, userInfo } = useUser();
  const [list, setList] = useState<Record<string, any>>([]);

  useEffect(() => {
    if (!isInit) return;

    if (isLogin) {
      setList(PRODUCT_REGION.KR === userInfo.country ? HOME_BANNER_KR : HOME_BANNER_GLOBAL);
    } else {
      setList(isKorean() ? HOME_BANNER_KR : HOME_BANNER_GLOBAL);
    }
  }, [isInit, isLogin, userInfo, i18n.languages[0]]);

  return (
    <ul>
      {Object.entries(list).map((item, index) => {
        return (
          <li key={index} className={index > 0 ? 'mt-2' : ''}>
            <BannerItem
              prefixCategory={item[0] === PRODUCT_CATEGORY.KARAOKE ? KY_PREFIX_KARAOKE : KY_PREFIX_BIXBY}
              category={item[0] === PRODUCT_CATEGORY.KARAOKE ? KY_KARAOKE_NAME : KY_BIXBY_NAME}
              title={t(item[0] === PRODUCT_CATEGORY.KARAOKE ? 'home/banner_karaoke_title' : 'home/banner_bixby_title')}
              link={item[1].link}
              bgColor={item[1].bgColor}
              bgImage={item[1].bgImage}
              icon={item[1].icon}
            />
          </li>
        );
      })}
      {/* <li>
        <BannerItem
          category="K-araoke"
          title={t('home/banner_karaoke_title')}
          link="/product/purchase"
          bgColor="#5441b4"
          bgImage="/assets/images/common/common-img-img-banner-karaoke.svg"
          icon=""
        />
      </li>
      <li className="mt-2">
        <BannerItem
          category="Bixby"
          title={t('home/banner_bixby_title')}
          link="/product/purchase"
          linkParams={{
            tab: PRODUCT_CATEGORY.BIXBY,
          }}
          bgColor="#0d9996"
          bgImage="/assets/images/common/common-img-img-banner-bixby.svg"
          icon=""
        />
      </li> */}
    </ul>
  );
}
